








































































































































































































































































































































































// import {addEmployee,queryEmployeeById,updateEmployee,ResetEmployee} from '@/api/employee'
import { queryClienteleById, addClientele, updateClientele, getConvertedScore,
  getMajorTypesAndSchools, getSavedIntentions, saveIntentions, getConsultantList } from '@/api/clientele'
import { regionData, codeToText, provinceAndCityData  } from 'element-china-area-data'
import router from '@/router';
const choiceOptions = ['化学', '生物', '地理', '政治'];
export default {
  data() {
    return {
      optType: '',//当前操作的类型，新增或者修改
      rechoice: choiceOptions, //再选科目
      isUpdate: false,
      isEditConsultant: false,
      originConsultantId: '',
      loading: false,
      isAvailable: true,
      // ---------------
      props: {
        multiple: true, // 允许多选
        // checkStrictly: true, // 允许单独选择省或市
        label: "label",
        value: "value",
      },
      provinceAndCityOptions: provinceAndCityData, // 省市二级联动数据
      selectedProvinceAndCityOptions: [], // 选中的地区代码
      selectedCityNames: [], // 选中的地区名称

      // 专业类别信息
      // 专业类别信息
      majorTypesProps:{
        multiple: true,
        // lazy: true,
        // lazyLoad: this.loadSubOptions,
        checkStrictly: false
      },
      majorTypeOptions: [],
      selectedMajorTypeOptions: [],
      selectedMajorTypes: [],
      // 院校信息
      schoolOptions: [],
      selectedSchoolOptions: [],
      // 院校特色信息
      schoolSpecialtyOptions: [],
      selectedSchoolSpecialtyOptions: [],
      // 院校类型信息
      schoolTypeOptions: [],
      selectedSchoolTypeOptions: [],
      // 院校性质信息
      schoolIsPublicOptions: [],
      selectedSchoolIsPublicOptions: [],

      // ---------------
      consultantList: [],



      ruleForm: {

        stuName: '', // 学生姓名
        stuGender: '1', // 学生性别
        stuFolk: '', // 学生民族
        stuPhone: '', // 学生手机号
        pwd: '', // 学生端登陆密码
        originConsultantId: '', // 修改前咨询师id
        consultantId: '',
        consultantName: '', // 咨询师姓名
        accountStatus: 1, // 学生登录账户状态： 0：不可登录 1：可用
        examProvince: '', // 学生高考省份
        examYear: '', // 高考年份
        schoolName: '', // 学校名称
        subjectType: '物理类', // 科类
        checkedChoices: [],
        rechoice1: '', // 再选科目1
        rechoice2: '', // 再选科目2
        convertedScore: '', // 折算分数
        score: '', // 成绩
        // -----------------------------
        chineseScore: '', // 语文成绩
        mathScore: '', // 数学成绩
        foreignScore: '', // 外语成绩
        compreScore: '', // 综合成绩
        addScoreItem: 0, // 加分项
        foreignType: '', // 外语语种
        intentionalSchool: '', //意向院校
        intentionalMajor: '', // 意向专业
        // -----------------------------
        censusRegister: '', // 户籍
        politicalComplexion: '', // 政治面貌
        health: '', // 体检
        healthDetail: '', // 体检详情

        planningDetail: '', // 方案表详情（链接？）

        // --------------
        name: '',
        username: '',
        sex: '1',
        phone: '',
        idNumber: ''
      },
      rules: {
        stuName: [
            { required: true, message: '请输入学生姓名', trigger: 'blur' }
        ],
        stuFolk: [
            { required: true, message: '请输入学生民族', trigger: 'blur' }
        ],
        stuPhone: [
          { required: true, trigger: 'blur',validator: (rule,value,callback) => {
              if(value === '' || (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))){
                callback(new Error('请输入正确的手机号！'))
              }else{
                callback()
              }
            }
          }
        ],
        examProvince: [
          { required: true, message: '请输入学生高考省份', trigger: 'blur' }
        ], // 学生高考省份
        examYear: [
          { required: true, message: '请输入学生高考年份', trigger: 'blur' }
        ], // 高考年份
        schoolName: [
          { required: true, message: '请输入学生学校名称', trigger: 'blur' }
        ], // 学校名称
        subjectType: [
          { required: true, message: '请输入学生科类', trigger: 'blur' }
        ], // 科类
        checkedChoices: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value.length !== 2) {
                callback(new Error('必须选择两个选项'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
          // { required: true, message: '请选择学生再选科目', trigger: 'blur' },
          // { type: 'array', required: true, message: '请选择两个再选科目', trigger: 'change' }

        ],
        rechoice1: [
          { required: true, message: '请输入学生再选科目1', trigger: 'blur' }
        ], // 再选科目1
        rechoice2: [
          { required: true, message: '请输入学生再选科目2', trigger: 'blur' }
        ], // 再选科目2
        convertedScore: [
          { required: true, message: '请输入折算成绩', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!/^[1-9]\d*$/.test(value)) {
                callback(new Error('请输入正整数'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        score: [
          { required: true, message: '请输入学生成绩', trigger: 'blur' },
          {
            // validator: (rule, value, callback) => {
            //   if (!/^[1-9]\d*$/.test(value)) {
            //     callback(new Error('请输入正整数'));
            //   } else {
            //     callback();
            //   }
            // },
            validator: (rule, value, callback) => {
              // 该正则表达式匹配：
              // - 整数部分为非0开头的正整数，可选小数部分（最多2位）
              // - 或者整数部分为0，且小数部分必须是1-2位且不全为0（例如 0.1、0.12）
              if (!/^(?:[1-9]\d*(?:\.\d{1,2})?|0\.(?:[1-9]\d?))$/.test(value)) {
                callback(new Error('请输入正实数，最多保留两位小数'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ], // 成绩
        //------------------
        chineseScore: [
          { required: true, message: '请输入学生语文成绩', trigger: 'blur' },
          {
            // validator: (rule, value, callback) => {
            //   if (!/^[1-9]\d*$/.test(value)) {
            //     callback(new Error('请输入正整数'));
            //   } else {
            //     callback();
            //   }
            // },
            validator: (rule, value, callback) => {
              // 该正则表达式匹配：
              // - 整数部分为非0开头的正整数，可选小数部分（最多2位）
              // - 或者整数部分为0，且小数部分必须是1-2位且不全为0（例如 0.1、0.12）
              if (!/^(?:[1-9]\d*(?:\.\d{1,2})?|0\.(?:[1-9]\d?))$/.test(value)) {
                callback(new Error('请输入正实数，最多保留两位小数'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ], // 语文成绩
        mathScore: [
          { required: true, message: '请输入学生数学成绩', trigger: 'blur' },
          {
            // validator: (rule, value, callback) => {
            //   if (!/^[1-9]\d*$/.test(value)) {
            //     callback(new Error('请输入正整数'));
            //   } else {
            //     callback();
            //   }
            // },
            validator: (rule, value, callback) => {
              // 该正则表达式匹配：
              // - 整数部分为非0开头的正整数，可选小数部分（最多2位）
              // - 或者整数部分为0，且小数部分必须是1-2位且不全为0（例如 0.1、0.12）
              if (!/^(?:[1-9]\d*(?:\.\d{1,2})?|0\.(?:[1-9]\d?))$/.test(value)) {
                callback(new Error('请输入正实数，最多保留两位小数'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ], // 数学成绩
        foreignScore: [
          { required: true, message: '请输入学生外语成绩', trigger: 'blur' },
          {
            // validator: (rule, value, callback) => {
            //   if (!/^[1-9]\d*$/.test(value)) {
            //     callback(new Error('请输入正整数'));
            //   } else {
            //     callback();
            //   }
            // },
            validator: (rule, value, callback) => {
              // 该正则表达式匹配：
              // - 整数部分为非0开头的正整数，可选小数部分（最多2位）
              // - 或者整数部分为0，且小数部分必须是1-2位且不全为0（例如 0.1、0.12）
              if (!/^(?:[1-9]\d*(?:\.\d{1,2})?|0\.(?:[1-9]\d?))$/.test(value)) {
                callback(new Error('请输入正实数，最多保留两位小数'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ], // 外语成绩
        compreScore: [
          { required: true, message: '请输入学生综合成绩', trigger: 'blur' },
          {
            // validator: (rule, value, callback) => {
            //   if (!/^[1-9]\d*$/.test(value)) {
            //     callback(new Error('请输入正整数'));
            //   } else {
            //     callback();
            //   }
            // },
            validator: (rule, value, callback) => {
              // 该正则表达式匹配：
              // - 整数部分为非0开头的正整数，可选小数部分（最多2位）
              // - 或者整数部分为0，且小数部分必须是1-2位且不全为0（例如 0.1、0.12）
              if (!/^(?:[1-9]\d*(?:\.\d{1,2})?|0\.(?:[1-9]\d?))$/.test(value)) {
                callback(new Error('请输入正实数，最多保留两位小数'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ], // 综合成绩
        addScoreItem: [
          // { required: false, message: '', trigger: 'blur' },
          {
            // validator: (rule, value, callback) => {
            //   if (!/^[1-9]\d*$/.test(value)) {
            //     callback(new Error('请输入正整数'));
            //   } else {
            //     callback();
            //   }
            // },
            validator: (rule, value, callback) => {
              if(value === '' || value === 0 || value === null || value === undefined) {
                // alert(value)
                callback();
                return;
              }
              // 该正则表达式匹配：
              // - 整数部分为非0开头的正整数，可选小数部分（最多2位）
              // - 或者整数部分为0，且小数部分必须是1-2位且不全为0（例如 0.1、0.12）
              if (!/^(?:[1-9]\d*(?:\.\d{1,2})?|0\.(?:[1-9]\d?))$/.test(value)) {
                callback(new Error('请输入正实数，最多保留两位小数'));
              } else {
                const num = parseFloat(value);
                if (num < 0 || num > 20) {
                  callback(new Error('请输入0到20之间的数字'));
                } else {
                  callback();
                }
              }
            },
            trigger: 'blur'
          }
        ],
        foreignType: [
          { required: true, message: '请输入学生综合成绩', trigger: 'blur' },
        ], // 外语语种
        intentionalSchool: [
          { required: true, message: '请输入学生综合成绩', trigger: 'blur' }
        ], // 意向院校
        intentionalMajor: [
          { required: true, message: '请输入学生综合成绩', trigger: 'blur' }
        ], // 意向专业
        //--------------
        censusRegister: [
          { required: true, message: '请输入学生户籍', trigger: 'blur' }
        ], // 户籍
        politicalComplexion: [
          { required: true, message: '请输入学生政治面貌', trigger: 'blur' }
        ], // 政治面貌
        health: [
          { required: true, message: '请输入学生体检结果', trigger: 'blur' }
        ],

      }
    }
  },
  created() {
    //获取路由参数（id），如果有则为修改操作，否则为新增操作
    this.optType = this.$route.query.id ? 'update' : 'add'
    if(this.optType === 'update') {
      this.loading = true
      //修改操作，需要根据id查询员工信息用于页面回显
      queryClienteleById(this.$route.query.id).then(res => {
        if(res.data.code === 1){
          this.ruleForm = res.data.data
          this.isAvailable = (this.ruleForm.accountStatus === 1)
          // console.log(this.ruleForm)
        }
      })
      // 加载专业类
      this.getMajorTypesFromServer()
      this.getIntentions()
      this.loading = false
      this.isUpdate = true
    }
  },
  computed: {
    // selectedTheCityNames() {
    //   return this.selectedProvinceAndCityOptions.map(code => codeToText[code] || code);
    // },
    MajorTypesContent(){
      // 格式化为 "批次-二级类目" 的字符串
      return this.selectedMajorTypes
        .map(item => `${item.pc}-${item.secondLevelCategory}`)
        .join(', ');
    },

  },
  methods: {

    handleMajorTypeChange(selected){
      // console.log(selected)
      // this.selectedMajorTypes = [];
      // console.log("原始选中数据: ", selected);

      // 过滤选中数据，仅保留批次（第一级）和二级类目（第三级）
      this.selectedMajorTypes = selected
        .map(item => {
          if (item.length === 3) {
            // 只返回批次ID（item[0]）和二级类目ID（item[2]）
            return {
              pc: item[0],
              firstLevelCategory: item[1],
              secondLevelCategory: item[2]
            };
          }
          return null;
        })
        .filter(item => item !== null); // 过滤掉无效项

      // console.log("处理后的选中数据: ", this.selectedMajorTypes);
    },

    // 生成随机字符串(学生端登陆密码)
    /*
    generateRandomString() {
      const length = 10; // 随机字符串的长度
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$%^&*()_+!';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      console.log(result);
      this.ruleForm.pwd = result; // 更新表单数据
    },
    */
    //--------------------------------意向数据操作--------------------------------
    // 处理选中项，将地区代码转换为名称
    handleCityChange(values) {
      // console.log(values)
      // console.log("value:"+values.at(-1))
      this.selectedCityNames = values.map((code) => this.findNameByCode(code.at(-1)));
      // console.log(this.selectedProvinceAndCityOptions)

    },

    // 根据地区代码查找对应的省市名称
    findNameByCode(code) {
      // console.log(code)
      for (let province of provinceAndCityData) {
        if (province.value === code) return province.label; // 省级匹配
        for (let city of province.children || []) {
          if (city.value === code) return city.label; // 市级匹配
        }
      }
      return "未知地区";
    },
    findCodeByName(name){
      // console.log("name:"+name)
      for (let province of provinceAndCityData) {
        // if (province.label === name) return province.value; // 省级匹配
        // console.log(province)
        for (let city of province.children || []) {
          if (city.label === name) return [province.value, city.value]; // 市级匹配
        }
      }
      return null;
    },
    loadSelecetedCityOptions(){
      // console.log("selectedCityNames: "+this.selectedCityNames)
      for(let city of this.selectedCityNames){
        this.selectedProvinceAndCityOptions = this.selectedCityNames.map(city => this.findCodeByName(city));

        // this.selectedProvinceAndCityOptions.push(this.findCodeByName(city))
      }
      // console.log("load:"+this.selectedProvinceAndCityOptions)
    },
    loadSelectedMajorTypesOptions(){

      this.selectedMajorTypeOptions = this.selectedMajorTypes.map(item => [
        item.pc,
        item.firstLevelCategory,
        item.secondLevelCategory
      ]);
      // console.log("selectedMajorTypes:", this.selectedMajorTypes)
      // console.log("selectedMajorTypeOptions:", this.selectedMajorTypeOptions)
    },
    getMajorTypesFromServer(){
      getMajorTypesAndSchools().then( res => {
        if (res.data.code === 1) {
          // this.$message.success('个人信息维护成功！')
          // this.$router.push('/stuDashboard')
          // this.majorTypeOptions = res.data.data.majorTypes
          this.majorTypeOptions = res.data.data.categoryList
          this.schoolOptions = res.data.data.schools

          this.schoolTypeOptions = res.data.data.schoolType
          this.schoolSpecialtyOptions = res.data.data.schoolSpeciality
          this.schoolIsPublicOptions = res.data.data.schoolIspublic
          // console.log(this.majorTypeOptions)
          // console.log(res.data.data)
        } else {
          this.$message.error('专业类别加载失败！' + res.data.msg)
        }
      })

    },

    getIntentions(){
      getSavedIntentions(this.$route.query.id).then(res => {
        if(res.data.code === 1){
          // 不想去的城市
          this.selectedCityNames = res.data.data.regions === null ? [] : res.data.data.regions
          // 意向院校
          this.selectedSchoolOptions = res.data.data.additionalColleges === null ? [] : res.data.data.additionalColleges
            // 意向专业类
          // this.selectedMajorTypeOptions = res.data.data.majorTypes
          this.selectedMajorTypes = res.data.data.majorTypes === null ? [] : res.data.data.majorTypes

            // this.selectedSchoolSpecialtyOptions = res.data.data.schoolSpecialitys
          // this.selectedSchoolTypeOptions = res.data.data.schoolTypes
          // this.selectedSchoolIsPublicOptions = res.data.data.schoolIsPublic

          this.selectedSchoolSpecialtyOptions = res.data.data.schoolSpecialitys === null ? [] : res.data.data.schoolSpecialitys
          this.selectedSchoolTypeOptions = res.data.data.schoolTypes === null ? [] : res.data.data.schoolTypes
          this.selectedSchoolIsPublicOptions = res.data.data.schoolIsPublic === null ? [] : res.data.data.schoolIsPublic
                // console.log(this.selectedSchoolSpecialtyOptions)


          this.loadSelecetedCityOptions()
          this.loadSelectedMajorTypesOptions()
          // console.log(this.selectedProvinceAndCityOptions)
          // console.log(this.selectedCityNames)
        }
      })
    },
    // 保存学生意向
    saveStuIntentions(){
      const data = {
        clienteleId: this.$route.query.id,
        // majorTypes: this.selectedMajorTypeOptions,
        majorTypes: this.selectedMajorTypes,
        regions: this.selectedCityNames,
        additionalColleges: this.selectedSchoolOptions,

        schoolSpecialitys: this.selectedSchoolSpecialtyOptions,
        schoolTypes: this.selectedSchoolTypeOptions,
        schoolIsPublic: this.selectedSchoolIsPublicOptions
      }
      // console.log(data)
      saveIntentions(data).then(res => {
        if(res.data.code === 1){
          this.$message.success("意向信息保存成功！")
          // this.$router.push('/intention')
        } else {
          this.$message.error('意向信息保存失败！' + res.data.msg)
        }
      })
    },

    //--------------------------------意向数据操作--------------------------------
    // 计算折算成绩
    calConvertedScore(){

      getConvertedScore(this.$route.query.id).then(res => {
        if(res.data.code === 1){
          this.ruleForm.convertedScore = res.data.data;
        }else{
          this.$message.error("计算出错")
        }
      })
    },
    fillTotal(){
      // console.log("fill:",this.isAvailable)
      if(this.isAvailable){
        this.ruleForm.accountStatus = 1
      }else {
        this.ruleForm.accountStatus = 0
        // console.log(this.ruleForm.accountStatus)
      }
    },
    generateRandomString(){
      const length = 12;
      const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      const lowercase = 'abcdefghijklmnopqrstuvwxyz';
      const numbers = '0123456789';
      const symbols = '!@#$%^&*()_+-=[]{}|;,.<>?/';

      const allChars = uppercase + lowercase + numbers + symbols; // 所有字符集合
      let password = '';

      // 确保密码包含至少一个大写字母、一个小写字母、一个数字和一个特殊字符
      password += uppercase[Math.floor(Math.random() * uppercase.length)];
      password += lowercase[Math.floor(Math.random() * lowercase.length)];
      password += numbers[Math.floor(Math.random() * numbers.length)];
      password += symbols[Math.floor(Math.random() * symbols.length)];

      // 填充剩余长度
      for (let i = password.length; i < length; i++) {
        password += allChars[Math.floor(Math.random() * allChars.length)];
      }

      // 打乱密码顺序（避免前四个字符固定为大写、小写、数字、特殊字符）
      password = password.split('').sort(() => Math.random() - 0.5).join('');
      this.ruleForm.pwd = password;
      // console.log(password);
    },

    editConsultant(){
      this.isEditConsultant = true
      this.originConsultantId = this.ruleForm.consultantId
      this.ruleForm.originConsultantId = this.ruleForm.consultantId

      if(this.consultantList.length === 0){

        getConsultantList().then(res => {
          if(res.data.code === 1){
            this.consultantList = res.data.data
          }
        })
      }
    },
    changeConsultant(isSave){
      if(!isSave){
        this.ruleForm.consultantId = this.originConsultantId
      }else{
        for (let con of this.consultantList){
          if(con.id === this.ruleForm.consultantId){
            this.ruleForm.consultantName = con.name
            this.ruleForm.originConsultantId = this.originConsultantId
            break
          }
        }

      }
      // alert(this.ruleForm.consultantId)

      this.isEditConsultant = false
    },
    validateSelection(){
      if (this.ruleForm.checkedChoices.length < 2) {
        this.errorMessage = '请至少选择两个选项';
      } else if (this.ruleForm.checkedChoices.length > 2) {
        this.errorMessage = '您最多只能选择两个选项';
      } else {
        this.errorMessage = '';
      }
    },

    submitForm(formName,isContinue) {
      this.$confirm('请确认信息无误', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //进行表单校验
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.ruleForm.rechoice1 = this.ruleForm.checkedChoices[0]
            this.ruleForm.rechoice2 = this.ruleForm.checkedChoices[1]

            this.fillTotal()

            if(this.ruleForm.pwd === null || this.ruleForm.pwd === '' || this.ruleForm.pwd === undefined){
              this.generateRandomString();
            }
            updateClientele(this.ruleForm).then(res => {
              if (res.data.code === 1) {
                this.$message.success('客单信息修改成功！')
                // this.$router.push('/consultantDashboard')
              }else{
                this.$message.error('客单信息修改失败！' + res.data.msg)
              }
            })
            this.saveStuIntentions()



          }
        })
        // this.$message({
        //   type: 'success',
        //   message: '删除成功!'
        // });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });

    }
    // resetPwd(){
    //   ResetEmployee(this.$route.query.id).then(res =>{
    //     if(res.data.code === 1){
    //       this.$message.success('员工密码重置成功！')
    //     }
    //   })
    // }
  }
}
